export default {
  placeholder: 'Wählen Sie ein Ereignis aus',
};
